import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { getHits } from "../../../../../redux/reducers";
import { getHitsState } from "../../../../../redux/selectors";
import styles from "./index.module.scss";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";

interface ICard {
  image: string;
  name: string;
  price: string;
}

const BestSells = () => {
  const hits = useAppSelector((state) => getHitsState(state));
  const [loader, setLoader] = useState<boolean>(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getHits()).then(() => {
      setLoader(false);
    });
  }, []);

  const prices = new Intl.NumberFormat("ru-RU", {
    currency: "RUB",
    style: "currency",
  });
  if (loader) {
    return (
      <div className={styles.bestSells}>
        <div className="container">
          <h2 className="title">Хиты продаж</h2>
          <div className={`${styles.cards} ${styles.loading}`}>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div className={`${styles.loadingCard} ${styles.isLoading}`}>
              <div className={styles.image}></div>
            </div>
            <div
              className={`${styles.loadingCard} ${styles.isLoading}  ${styles.last}`}
            >
              <div className={styles.image}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.bestSells}>
      <div className="container">
        <h2 className="title">Хиты продаж</h2>
        <div className={styles.cards}>
          {hits.map(({ hitProductId, catalog }, i) => (
            <Link to={`/details/v1/hits/${hitProductId}`}>
              <Card
                key={hitProductId}
                image={catalog.image.imagePath}
                name={catalog.catalogName}
                price={prices.format(catalog.price)}
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

const Card = ({ image, name, price }: ICard) => (
  <div className={styles.card}>
    <img src={image} alt="image" />
    <h4>{price}</h4>
    <h5>{name}</h5>
  </div>
);

export default BestSells;
